var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6032 13.4017H4.26984V4.06836H11.6032M11.6032 2.73503H4.26984C3.91621 2.73503 3.57708 2.8755 3.32703 3.12555C3.07698 3.3756 2.9365 3.71474 2.9365 4.06836V13.4017C2.9365 13.7553 3.07698 14.0945 3.32703 14.3445C3.57708 14.5946 3.91621 14.735 4.26984 14.735H11.6032C11.9568 14.735 12.2959 14.5946 12.546 14.3445C12.796 14.0945 12.9365 13.7553 12.9365 13.4017V4.06836C12.9365 3.71474 12.796 3.3756 12.546 3.12555C12.2959 2.8755 11.9568 2.73503 11.6032 2.73503ZM9.60317 0.0683594H1.60317C1.24955 0.0683594 0.910409 0.208835 0.660361 0.458884C0.410312 0.708932 0.269836 1.04807 0.269836 1.40169V10.735H1.60317V1.40169H9.60317V0.0683594Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a0c6d2108c6bd6c7d1311f006c63a94d.svg";
export { ForwardRef as ReactComponent };